import { render, staticRenderFns } from "./FiltersBase.vue?vue&type=template&id=55b12950&"
import script from "./FiltersBase.vue?vue&type=script&lang=ts&"
export * from "./FiltersBase.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersBase.vue?vue&type=style&index=0&id=55b12950&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports